import manifest from "../../../../config/questionnaire-text-limits.json";

/**
 * The text limits of a questionnaire draft, owned by
 * `config/questionnaire-text-limits.json`. Python reads the same file
 * (`apps/python-api/models/questionnaire/text_limits.py`). Every TypeScript
 * reader of these limits derives from here.
 */
const KEYS = [
  "studyObjectiveMaxChars",
  "studyObjectiveMaxBullets",
  "assetNameMaxChars",
  "assetDescriptionMaxWords",
  "questionLabelMaxChars",
] as const;

if (
  manifest.schemaVersion !== "questionnaire-text-limits.v1" ||
  Object.keys(manifest).length !== KEYS.length + 1 ||
  KEYS.some((key) => !Number.isInteger(manifest[key]) || manifest[key] < 1)
) {
  throw new TypeError("Questionnaire text-limit registry is malformed.");
}

/** One budget for the whole study objective: the decision and its learning objectives. */
export const STUDY_OBJECTIVE_MAX_CHARS: number = manifest.studyObjectiveMaxChars;

/** The most learning objectives an objective lists: more is a list, not a study. */
export const STUDY_OBJECTIVE_MAX_BULLETS: number =
  manifest.studyObjectiveMaxBullets;

/**
 * A tested asset's stored display name. Claim (`message`) titles stay
 * unbounded because the Title field is the stimulus.
 */
export const DEFAULT_MAX_ASSET_NAME_LENGTH: number = manifest.assetNameMaxChars;

/**
 * A tested asset's description, and the shared asset context, in words: a
 * soft ceiling legitimate studies never approach.
 */
export const MAX_ASSET_DESCRIPTION_WORDS: number =
  manifest.assetDescriptionMaxWords;

/**
 * An option, row, category or measure label: the deck's own `maxLength` for
 * these fields (`packages/slide-schemas/presets/*.schema.json`), which a test
 * pins, so the builder refuses what the deck cannot render.
 */
export const MAX_QUESTION_LABEL_LENGTH: number = manifest.questionLabelMaxChars;
